import { useEffect, useState, useCallback } from "react";
import PageHeader from "../../components/layout/PageHeader";
import { Table } from "../../components/ui/Table";
import { termsApi } from "../../api/terms";
import toast from "react-hot-toast";
import type { Term } from "../../types";

function formatDate(dateStr?: string | null) {
  if (!dateStr) return "—";
  const [year, month, day] = dateStr.split("-");
  return `${month}/${day}/${year}`;
}

export default function ManageTerms() {
  const [terms, setTerms] = useState<Term[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchTerms = useCallback(() => {
    setLoading(true);
    termsApi
      .list()
      .then((data) => {
        const sorted = [...data].sort(
          (a, b) => b.year - a.year || (a.startDate ?? "").localeCompare(b.startDate ?? "")
        );
        setTerms(sorted);
      })
      .catch(() => toast.error("Failed to load terms"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchTerms();
  }, [fetchTerms]);

  const tableColumns = [
    {
      key: "name",
      header: "Name",
      render: (t: Term) => (
        <span className="flex items-center gap-2">
          <span className="font-medium text-stone-800">{t.name}</span>
          {t.campMinderSessionId != null && (
            <span className="text-xs font-medium text-blue-700 bg-blue-100 px-1.5 py-0.5 rounded">
              CampMinder
            </span>
          )}
        </span>
      ),
    },
    {
      key: "year",
      header: "Year",
      render: (t: Term) => <span className="text-stone-600">{t.year}</span>,
    },
    {
      key: "startDate",
      header: "Start Date",
      render: (t: Term) => <span className="text-stone-600">{formatDate(t.startDate)}</span>,
    },
    {
      key: "endDate",
      header: "End Date",
      render: (t: Term) => <span className="text-stone-600">{formatDate(t.endDate)}</span>,
    },
  ];

  return (
    <div>
      <PageHeader
        title="Term Info"
      />

      <div className="p-6 lg:p-8">
        <Table
          columns={tableColumns}
          data={terms}
          keyExtractor={(t) => t.id}
          loading={loading}
          emptyMessage="No terms found."
        />
      </div>
    </div>
  );
}
